import { render, staticRenderFns } from "./SharedTipsCredit.vue?vue&type=template&id=966a40c4&scoped=true&"
import script from "./SharedTipsCredit.vue?vue&type=script&lang=js&"
export * from "./SharedTipsCredit.vue?vue&type=script&lang=js&"
import style0 from "./SharedTipsCredit.vue?vue&type=style&index=0&id=966a40c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a40c4",
  null
  
)

export default component.exports